module.exports = __webpack_public_path__ + "static/sustainDemo-0afe91af4fc071294c031bff0fb63932.webm";